/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

/**
 * Structure providing encrypted data of required Secured Info.
 */
export type EncryptedData = {
    algorithm: EncryptedData.algorithm;
    /**
     * Cipher text of encrypted required Secured Info, which needs to be decrypted.
     */
    cipherText: string;
};

export namespace EncryptedData {

    export enum algorithm {
        JWE = 'JWE',
        PLAIN_TEXT = 'PLAIN_TEXT',
    }


}

